// Parsing degli importi digitati a mano. Le tastiere mobili producono la
// virgola nelle locale europee, e chi incolla un importo si porta dietro
// separatori di migliaia e simboli di valuta: `Number("12,50")` è NaN, che
// a valle diventa 0 e blocca il salvataggio senza spiegare perché.
//
//   parseAmount('12,50')    → 12.5
//   parseAmount('1.234,56') → 1234.56
//   parseAmount('1,234.56') → 1234.56
//   parseAmount('€ 12 ,5')  → 12.5
//   parseAmount('')         → NaN

export function parseAmount(input) {
  if (typeof input === 'number') return Number.isFinite(input) ? input : NaN
  let s = String(input ?? '')
    .replace(/[\s  ']/g, '')   // spazi (anche NBSP/narrow) e apostrofo svizzero
    .replace(/[^\d.,-]/g, '')            // simboli di valuta e lettere
  if (!s) return NaN

  const lastComma = s.lastIndexOf(',')
  const lastDot   = s.lastIndexOf('.')
  if (lastComma !== -1 && lastDot !== -1) {
    // Entrambi presenti: l'ULTIMO è il separatore decimale, l'altro è migliaia
    const decSep = lastComma > lastDot ? ',' : '.'
    const thouSep = decSep === ',' ? '.' : ','
    s = s.split(thouSep).join('').replace(decSep, '.')
  } else {
    // Un solo tipo di separatore: è decimale, TRANNE quando si comporta da
    // migliaia — più occorrenze ("1.234.567") o gruppo finale di 3 cifre
    // ("1.500" in Italia è millecinquecento, non uno e mezzo).
    const sep = lastComma !== -1 ? ',' : (lastDot !== -1 ? '.' : null)
    if (sep) {
      const parts = s.split(sep)
      const thousands = parts.length > 2 ||
        (parts.length === 2 && parts[1].length === 3 && parts[0] !== '')
      s = thousands ? parts.join('') : parts.join('.')
    }
  }

  const n = Number(s)
  return Number.isFinite(n) ? n : NaN
}

// Variante comoda dove un valore mancante vale zero (quote, percentuali…)
export function num(input) {
  const n = parseAmount(input)
  return Number.isFinite(n) ? n : 0
}
